import { BottomMenuItem } from '../models/bottom-menu-state.model';

export function componentsInclude(
    components: BottomMenuItem[],
    id: BottomMenuItem['id'],
): boolean {
    return components.some((c) => c.id === id);
}
